/**
 * A conferência da mesa, para o painel Participantes mostrar os controles dela
 * (docs/spec/room-menus.md). A chamada vive no RoomDesktop (useVoiceChat), que a oferece aqui.
 * Sem ela (as janelas próprias, que não têm a chamada; o celular, que tem o próprio botão), o painel
 * não mostra a conferência.
 */
import { createContext, useContext } from 'react';
import type { VoiceChat } from './useVoiceChat.js';

export const VoiceContext = createContext<VoiceChat | null>(null);

export const useRoomVoice = (): VoiceChat | null => useContext(VoiceContext);
